:host {
  display: block;
  color: var(--color-foreground);
  font-size: $font-m-size;
  font-family: $font-normal;
}
